import {UiComponentRendererPlugin} from "./UiComponentRendererPlugin";

export class UiComponentRendererPluginRegistry {
    private readonly plugins: Map<string, UiComponentRendererPlugin> = new Map();

    registerPlugin(plugin: UiComponentRendererPlugin): void {
        plugin.getSupportedComponentTypes()
                .forEach((componentType) => {
                    if (this.plugins.has(componentType)) {
                        throw new Error(`Renderer plugin for component type ${componentType} already registered`);
                    }
                    this.plugins.set(componentType, plugin);
                });
    }

    getPlugin(componentType: string): UiComponentRendererPlugin | undefined {
        return this.plugins.get(componentType);
    }

    getAvailablePlugins(): UiComponentRendererPlugin[] {
        return Array.from(this.plugins.values());
    }
}
